import React, { useCallback, useMemo } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import useRouter from '../../../../hooks/useRouter';
import useTypedSelector from '../../../../hooks/useTypedSelector';
import { MarketId } from '../../../../types/market';
import { getFilterIdFromParams } from '../../../../types/matchBetFilters';
import RoutesRedirectionFactory from '../../../../utils/routes/RoutesRedirectionFactory';
import { marketIdWithSpecifiers } from '../../selectors/lineUp.selector';

import LineUpOpenViewButton from './LineUpOpenViewButton';
import selectLineUpOpenViewButtonProps from './LineUpOpenViewButton.selector';

type SeeLineUpButtonContainerProps = {
  className?: string;
  teamId?: number;
  marketId?: MarketId;
  specialBetValue?: string;
  matchId: number;
  isFromMultichoice?: boolean;
};

const LineUpOpenViewButtonContainer = ({
  teamId,
  marketId,
  specialBetValue,
  matchId,
  isFromMultichoice = false,
  ...ownProps
}: SeeLineUpButtonContainerProps) => {
  const { history } = useRouter();
  const shouldInsertSBV = useMemo(() => marketId && !!~marketIdWithSpecifiers.indexOf(marketId), [marketId]);

  const onClick = useCallback(() => {
    history.push(
      RoutesRedirectionFactory.getLineUpRouteConfig(matchId, {
        state: {
          teamId,
          filterId: getFilterIdFromParams({
            marketId,
            sbv: specialBetValue && shouldInsertSBV ? specialBetValue : undefined,
            isFromMultichoice,
          }),
        },
      }),
    );
  }, [history, matchId, teamId, marketId, specialBetValue, shouldInsertSBV, isFromMultichoice]);

  const otherProps = useMemo(
    () => ({
      onClick,
    }),
    [onClick],
  );

  const selectorProps = useMemo(() => ({ matchId, teamId }), [matchId, teamId]);
  const { isVisible, sportId } = useTypedSelector((state) => selectLineUpOpenViewButtonProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, otherProps });

  return isVisible && sportId ? <LineUpOpenViewButton {...enhancedProps} sportId={sportId} /> : null;
};

export default LineUpOpenViewButtonContainer;
